<template>
  <div class="h-px w-full bg-white opacity-50"></div>
</template>
